import React from 'react';

import CateringSignInEmail, {
  CateringSignInEmailProps,
} from '@/components/catering/auth/CateringSignInEmail';
import { CateringProvider } from '@/components/shared/Provider';
import { createContainer } from '@/helpers/container_helper';

const CateringSignInEmailEntrypoint: React.FC<CateringSignInEmailProps> = (props) => (
  <CateringProvider>
    <CateringSignInEmail {...props} />
  </CateringProvider>
);

createContainer('catering-sign-in-email', CateringSignInEmailEntrypoint);
